<div class="search-container">
  <img class="search-icon" src="assets/icons/search.svg" alt="" />
  <input data-testid="search-input" type="text" class="search-input" [value]="searchTerm()" (input)="onSearchChange($any($event.target).value)" [placeholder]="placeholder() || ('general.search' | translate)" />
</div>
